import { render, staticRenderFns } from "./DataTableGroup.vue?vue&type=template&id=41116370&"
import script from "./DataTableGroup.vue?vue&type=script&lang=ts&"
export * from "./DataTableGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports